// Comprobante térmico de SALIDA — presentacional puro (oculto en pantalla, visible al imprimir).
import { fmtDateTime } from "@/lib/datetime";
export const SalidaThermalReceipt = ({ receipt, comisionCfg, paperWidth }) => {
  if (!receipt) return null;
  return (
    <div className={`thermal-receipt tr-w${paperWidth}`} data-testid="thermal-receipt">
      <div className="tr-center tr-brand" data-testid="tr-brand">{comisionCfg?.nombre || receipt.sucursal}</div>
      {comisionCfg?.direccion ? <div className="tr-center tr-sm" data-testid="tr-direccion">{comisionCfg.direccion}</div> : null}
      {comisionCfg?.rfc ? <div className="tr-center tr-sm" data-testid="tr-rfc">RFC: {comisionCfg.rfc}</div> : null}
      <div className="tr-center tr-sm">Sucursal: {receipt.sucursal}</div>
      <div className="tr-sep">--------------------------------</div>
      <div className="tr-center tr-bold">COMPROBANTE DE SALIDA</div>
      <div>Folio: {receipt.folio}</div>
      {receipt.placa ? <div>Placa: {receipt.placa}</div> : null}
      {receipt.tipo ? <div>Vehiculo: {receipt.tipo}</div> : null}
      <div>Salida: {fmtDateTime(receipt.fecha_salida)}</div>
      <div>Tiempo: {receipt.estancia}</div>
      <div className="tr-sep">--------------------------------</div>
      <div className="tr-row"><span>Estacionamiento</span><span>${receipt.estacionamiento.toFixed(2)}</span></div>
      {receipt.valet > 0 ? <div className="tr-row" data-testid="tr-valet"><span>Servicio de Valet</span><span>${receipt.valet.toFixed(2)}</span></div> : null}
      {receipt.productos > 0 ? <div className="tr-row"><span>Productos</span><span>${receipt.productos.toFixed(2)}</span></div> : null}
      {receipt.penalizacion > 0 ? <div className="tr-row" data-testid="tr-penalizacion"><span>Boleto perdido</span><span>${receipt.penalizacion.toFixed(2)}</span></div> : null}
      {receipt.propina > 0 ? <div className="tr-row" data-testid="tr-propina"><span>Propina (no facturable)</span><span>${receipt.propina.toFixed(2)}</span></div> : null}
      {receipt.cargo > 0 ? <div className="tr-row"><span>Cargo x servicio</span><span>${receipt.cargo.toFixed(2)}</span></div> : null}
      <div className="tr-row tr-bold tr-lg"><span>TOTAL</span><span>${receipt.total.toFixed(2)}</span></div>
      <div className="tr-sep">--------------------------------</div>
      <div>Pago: {receipt.metodo || "—"}</div>
      {receipt.folio_aut ? <div>Autorizacion: {receipt.folio_aut}</div> : null}
      <div className="tr-sep">--------------------------------</div>
      <div className="tr-center">Gracias por su visita</div>
    </div>
  );
};

export default SalidaThermalReceipt;
